/*
 * This file is part of the Neos.Neos.Ui package.
 *
 * (c) Contributors of the Neos Project - www.neos.io
 *
 * This package is Open Source Software. For the full copyright and license
 * information, please view the LICENSE file which was distributed with this
 * source code.
 */
import {unsetGlobals} from './globals';

/**
 * Unsets the previously registered locale and translations
 *
 * You may use this function for cleaning up after running setupI18n in a
 * testing scenario.
 */
export function teardownI18n(): void {
    unsetGlobals();
}
